// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"96":"84141ad9","535":"9d5ac195","708":"8c378eb1","761":"1df1b9ab","860":"8b6e35ae","870":"d7b175bf"}[chunkId] + ".js";
};